var chunkToChildrenMap = {
	"9332": [
		1706,
		8582,
		4737,
		879,
		7947,
		7164,
		4294,
		8814,
		7697,
		2259,
		7771,
		5067
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));